<script>
import lottie from "lottie-web";

export default {
  name: "LottieComponent",
  props: {
    data: {
      type: Object,
    },
    // Path to the Lottie animation JSON
    path: {
      type: String,
      required: true,
    },
    // Animation speed (1 is normal speed)
    speed: {
      type: Number,
      default: 1,
    },
    // Whether the animation should loop
    loop: {
      type: Boolean,
      default: true,
    },
    // Whether to autoplay the animation
    autoplay: {
      type: Boolean,
      default: true,
    },
    // Width of the animation container
    width: {
      type: String,
      default: "100%",
    },
    // Height of the animation container
    height: {
      type: String,
      default: "100%",
    },
    // Additional options for lottie-web
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      animationInstance: null,
    };
  },
  mounted() {
    this.loadAnimation();
  },
  beforeUnmount() {
    // Destroy the animation when component is unmounted
    if (this.animationInstance) {
      this.animationInstance.destroy();
    }
  },
  watch: {
    // Watch for changes in path to reload animation
    path() {
      this.loadAnimation();
    },
    // Watch for changes in speed
    speed() {
      if (this.animationInstance) {
        this.animationInstance.setSpeed(this.speed);
      }
    },
  },
  methods: {
    loadAnimation() {
      // Destroy previous animation if exists
      if (this.animationInstance) {
        this.animationInstance.destroy();
      }

      // For JSON files or direct paths, load normally
      this.createAnimationInstance({
        container: this.$refs.container,
        renderer: "svg",
        loop: this.loop,
        autoplay: this.autoplay,
        path: this.path,
        ...this.options,
      });
    },

    createAnimationInstance(config) {
      // Create new animation with the provided config
      this.animationInstance = lottie.loadAnimation(config);

      // Set animation speed
      this.animationInstance.setSpeed(this.speed);

      // Emit events
      this.animationInstance.addEventListener("DOMLoaded", () => {
        this.$emit("loaded");
      });
      this.animationInstance.addEventListener("complete", () => {
        this.$emit("complete");
      });
    },
    play() {
      if (this.animationInstance) {
        this.animationInstance.play();
      }
    },
    pause() {
      if (this.animationInstance) {
        this.animationInstance.pause();
      }
    },
    stop() {
      if (this.animationInstance) {
        this.animationInstance.stop();
      }
    },
  },
};
</script>

<template>
  <div ref="container" class="lottie-container" :style="{ width, height }"></div>
</template>

<style lang="stylus">
.lottie-container {
	display: inline-block
	overflow: hidden
}
</style>
